import firebase from 'firebase/app';
import 'firebase/firebase-firestore';
import 'firebase/firebase-auth';
import 'firebase/firebase-storage';

const firebaseConfig = {
  apiKey: "AIzaSyB8lxWdQs-oaf4mOdxWeshiFLNCRb7KQrM",
  authDomain: "uscinteractionlab.firebaseapp.com",
  databaseURL: "https://uscinteractionlab.firebaseio.com",
  projectId: "uscinteractionlab",
  storageBucket: "uscinteractionlab.appspot.com",
  messagingSenderId: "857159017212",
  appId: "1:857159017212:web:849e460da67d498aceed79",
  measurementId: "G-VL81JPW2S3"
};
const app = firebase.initializeApp(firebaseConfig);

const db = app.firestore();

// if (location.hostname === "localhost") {
//   db.settings({
//     host: "localhost:8080",
//     ssl: false
//   });
// }

export { app, db };